<template>
  <NIconWrapper v-tooltip="tooltip" :border-radius="100" :color="color" :iconColor="iconColor">
    <CIcon v-tooltip="tooltip" :faType="faType" :icon="icon" size="small" />
  </NIconWrapper>
</template>

<script lang="ts" setup>
import { NIconWrapper } from 'naive-ui'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import type { FontAwesomeType } from '@canvas-builder/types/font-awesome.types'
import tooltipDirective from '@lib/directives/tooltip'

const vTooltip = tooltipDirective

defineProps<{
  icon: string
  tooltip: string
  faType: FontAwesomeType
  color: string
  iconColor: string
}>()
</script>
